import { render, staticRenderFns } from "./AnexosOcorrencia.vue?vue&type=template&id=1d20fff7&scoped=true"
import script from "./AnexosOcorrencia.vue?vue&type=script&lang=js"
export * from "./AnexosOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./AnexosOcorrencia.vue?vue&type=style&index=0&id=1d20fff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20fff7",
  null
  
)

export default component.exports